import React from "react";
import { Card } from "@sscs/ui";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, } from "../../../../constants";
import { cveFiltered, dependencyTagFiltered, sourceFiltered, } from "../../../../store/vulnerabilitySlice";
import { Vulnerabilities } from "../../../../ui";
import { LinkToReportTab } from "../../../common";
import { filterByCve, filterByExploitTag, } from "../../../fileBrowser/store/vulnerabilitiesSlice";
import { useReportDispatch } from "../../../hooks";
import { exploitStatsToVulnerabilityMetrics, generateFileBrowserLink, } from "../../../utils";
import styles from "./softwareDetails.module.scss";
const SoftwareVulnerabilities = ({ software, rowIndex, }) => {
    const [searchParams] = useSearchParams();
    const dispatch = useReportDispatch();
    const isComponent = software.type === "COMPONENT";
    const fileBrowserLink = isComponent
        ? generateFileBrowserLink({
            searchParams,
            componentId: software.identity.uuid,
            componentPath: software.path,
            fileBrowserPage: FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE,
        })
        : null;
    const totalVulnsLinkTo = isComponent && fileBrowserLink
        ? fileBrowserLink
        : REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE;
    const handleLinkClick = () => {
        if (!isComponent) {
            dispatch(sourceFiltered({
                name: `${software.identity.product} ${software.identity.version}`,
                id: software.identity.uuid,
                type: "DEPENDENCY",
            }));
        }
    };
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { actions: React.createElement(LinkToReportTab, { id: "all-vulnerabilities", to: totalVulnsLinkTo, color: "link", onClick: handleLinkClick, className: styles["all-vulns-link"] },
                "All ",
                isComponent ? "Component" : "Dependency",
                " Vulnerabilities") }, "Vulnerabilities"),
        React.createElement(Card.Content, null,
            React.createElement(Vulnerabilities.Chart, { vulnerabilities: software.identity.vulnerabilities.lifecycle, vulnerabilityStatistics: exploitStatsToVulnerabilityMetrics(software.identity.vulnerabilities.exploit_tag_statistics, software.identity.vulnerabilities.total_count), totalCountWrapper: (children) => (React.createElement(LinkToReportTab, { id: `total-vulnerabilities-${rowIndex}`, to: totalVulnsLinkTo, onClick: handleLinkClick }, children)), moreWrapper: (tag, children) => (React.createElement(LinkToReportTab, { id: `more-${tag}-${rowIndex}`, to: totalVulnsLinkTo, color: "link", onClick: () => isComponent
                        ? dispatch(filterByExploitTag(tag))
                        : dispatch(dependencyTagFiltered({
                            name: `${software.identity.product} ${software.identity.version}`,
                            id: software.identity.uuid,
                            exploit_type: [tag],
                        })) }, children)), vulnerabilityWrapper: (vulnerability, children) => (React.createElement(Vulnerabilities.Tooltip, { key: vulnerability.cve, cvss: vulnerability.cvss, exploit: vulnerability.exploit },
                    React.createElement(LinkToReportTab, { id: vulnerability.cve, to: isComponent && fileBrowserLink
                            ? fileBrowserLink
                            : REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE, color: "link", onClick: () => isComponent
                            ? dispatch(filterByCve(vulnerability.cve))
                            : dispatch(cveFiltered(vulnerability.cve)) }, children))) }))));
};
export default SoftwareVulnerabilities;
//# sourceMappingURL=SoftwareVulnerabilities.js.map